import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { validateName } from 'utils/formValidator';
const nameField = 'name';
export const EditModal = ({ confirmName, isLoading, name: propName, title, onClose, onSubmit, }) => {
    const [name, setName] = useState(propName);
    const [errors, setErrors] = useState({});
    const validate = useCallback(() => {
        const errors = {};
        const nameError = validateName(name);
        if (nameError) {
            errors[nameField] = nameError;
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }, [name]);
    const handleSubmit = useCallback(() => {
        if (!validate())
            return;
        onSubmit({ name });
    }, [name, onSubmit, validate]);
    const handleNameChange = useCallback((event) => {
        if (!event)
            return;
        setName(event.target.value);
    }, []);
    return (_jsx(Modal, Object.assign({ isOpen: true, onClose: onClose }, { children: _jsx(Box, Object.assign({ width: "456px" }, { children: _jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(ModalHead, { title: title, onClose: onClose }), _jsx(ModalBody, { children: _jsx(FieldText, { label: "Name", placeholder: "e.g. 'Italy' or 'HR Department'", required: true, input: {
                                name: nameField,
                                onChange: handleNameChange,
                                value: name,
                            }, meta: { error: errors[nameField] } }) }), _jsx(ModalFoot, { cancelOnClick: onClose, confirmProps: { disabled: name === propName, isLoading }, confirmName: confirmName || 'Update', confirmOnClick: handleSubmit })] })) })) })));
};
